/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Oct 01 2021 15:07:31 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.PAYMENT;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface PAYListResponse {
  ciid: number;
  cireference: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  payamount: number;
  paynetamount: number;
  paydirection: string;
  paydocdate: string;
  paydocreference: string;
  payid: number;
  paymode: string;
  paymodelabel: string;
  payreference: string;
  payrejected: boolean;
  payremainingamount: number;
  paystatus: string;
  paytype: string;
  siid: number;
  sireference: string;
  statuslabel: string;
  tpid: number;
  tpname: string;
  tpreference: string;
}

export interface PayNetODRequest {
  listCredit: Array<listCredit>;
  listDebit: Array<listDebit>;
  paynetop: string;
  currcode: string;
}

export interface PayNetting {
  accountingreference: string;
  ciid: number;
  ciidcreditnote: number;
  cisid: number;
  ctrid: number;
  flagod: boolean;
  jobid: number;
  payidlinked: number;
  payment: Payment;
  paynetallocation: string;
  paynetamount: number;
  paynetdate: string;
  paynetid: number;
  paynetorder: number;
  paynetreference: string;
  paynetstatus: string;
  paynettype: string;
  siid: number;
  siidcreditnote: number;
  sisid: number;
  currcode: string;
}

export interface PayNettingResponse {
  accountingreference: string;
  cidocdate: string;
  cidueamount: string;
  cigrosstotal: string;
  ciid: number;
  ciidcreditnote: number;
  cireference: string;
  cisid: number;
  created_at: string;
  created_by: number;
  ctreference: string;
  ctrid: number;
  flagod: boolean;
  jobid: number;
  last_action: string;
  objectreference: string;
  payid: number;
  payidlinked: number;
  paynetallocation: string;
  paynetamount: number;
  paynetdate: string;
  paynetid: number;
  paynetorder: number;
  paynetreference: string;
  paynetstatus: string;
  paynettype: string;
  siid: number;
  siidcreditnote: number;
  sisid: number;
  updated_at: string;
  updated_by: number;
  currcode: string;
}

export interface PayNettingViewResponse {
  accountingreference: string;
  ciid: number;
  ciidcreditnote: number;
  cisid: number;
  credit: number;
  ctrid: number;
  debit: number;
  flagod: boolean;
  jobid: number;
  payreference: string;
  objectreference: string;
  operationlabel: string;
  payid: number;
  payidlinked: number;
  paynetallocation: string;
  paynetamount: number;
  paynetdate: string;
  paynetid: number;
  paynetorder: number;
  paynetreference: string;
  paynetstatus: string;
  paynettype: string;
  siid: number;
  siidcreditnote: number;
  sisid: number;
  statuslabel: string;
  currcode: string;
  payremainingamount: number;
}

export interface Payment {
  accountingdate: string;
  accountingreference: string;
  createdAt: string;
  createdBy: number;
  currcode: string;
  jobid: number;
  lastAction: string;
  mgid: number;
  payNettings: Array<PayNetting>;
  payamount: number;
  paydate: string;
  paydirection: string;
  paydocdate: string;
  paydocreference: string;
  payduedate: string;
  payid: number;
  payidreject: number;
  paymgbankaccount: number;
  paymode: string;
  payprocessdate: string;
  payreference: string;
  payrejectdate: string;
  payrejected: boolean;
  payrejectfeesamount: number;
  payrejectreason: string;
  payremainingamount: number;
  paystatus: string;
  paytpbankaccount: string;
  paytype: string;
  tpid: number;
  updatedAt: string;
  updatedBy: number;
}

export interface PaymentRequest {
  accountingdate: string;
  accountingreference: string;
  currcode: string;
  jobid: number;
  mgid: number;
  payNettings: Array<PayNetting>;
  payamount: number;
  paydate: string;
  paydirection: string;
  paydocdate: string;
  paydocreference: string;
  payduedate: string;
  payid: number;
  payidreject: number;
  paymgbankaccount: number;
  paymode: string;
  payprocessdate: string;
  payreference: string;
  payrejectdate: string;
  payrejected: boolean;
  payrejectfeesamount: number;
  payrejectreason: string;
  payremainingamount: number;
  paystatus: string;
  paytpbankaccount: string;
  paytype: string;
  tpid: number;
  tpbkid: number;
  last_action: number;
  bkreconsiliationref:string;
  bkreconsilationdate:string;
}

export interface PaymentResponse {
  accountingdate: string;
  accountingreference: string;
  clientname: string;
  createdBy: UserSummary;
  currcode: string;
  jobid: number;
  mgid: number;
  payNettings: Array<PayNettingResponse>;
  payamount: number;
  paydate: string;
  paydirection: string;
  paydocdate: string;
  paydocreference: string;
  payduedate: string;
  payid: number;
  payidreject: number;
  paymgbankaccount: number;
  paymode: string;
  paymodelabel: string;
  payprocessdate: string;
  payreference: string;
  payrejectdate: string;
  payrejected: boolean;
  payrejectfeesamount: number;
  payrejectreason: string;
  payrejectreasonLabel: string;
  payremainingamount: number;
  paystatus: string;
  paytpbankaccount: string;
  paytype: string;
  paytypelabel: string;
  refrejet: string;
  statuslabel: string;
  tpAddress: tpAddressResponse;
  tpContact: tpContactResponse;
  tpGeneralData: tpGeneralDataResponse;
  tpid: number;
  paynbrepresentation?: number;
  paydaterepresentation?: string;
  payrefrepresentation?: string;
  bkreconsiliationref:string;
  bkreconsilationdate:string;
}

export interface SupplierFlowResponse {
  credit: number;
  debit: number;
  docdate: string;
  flowtype: string;
  flowtypeLable: string;
  objectid: number;
  objectreference: string;
  paystatus: string;
  paystatusLabel: string;
  remaining: number;
  suspense: number;
  tpid: number;
  tpname: string;
  tpreference: string;
}

export interface UserSummary {
  email: string;
  id: number;
  lancode: string;
  locked: boolean;
  mgid: number;
  mobile: string;
  name: string;
  phone: string;
  status: string;
  surname: string;
  username: string;
  userrole: string;
}

export interface clientFlowResponse {
  credit: number;
  debit: number;
  docdate: string;
  flowtype: string;
  flowtypeLable: string;
  objectid: number;
  objectreference: string;
  paystatus: string;
  paystatusLabel: string;
  remaining: number;
  suspense: number;
  tpid: number;
  tpname: string;
  tpreference: string;
}

export interface listCredit {
  ciid: number;
  ciidcreditnote: number;
  cisid: number;
  ctrid: number;
  payid: number;
  payidlinked: number;
  paynetallocation: string;
  paynetamount: number;
  paynetdueamount: number;
  paynetid: number;
  paynetstatus: string;
  paynettype: string;
  siid: number;
  siidcreditnote: number;
  sisid: number;
}

export interface listDebit {
  ciid: number;
  ciidcreditnote: number;
  cisid: number;
  ctrid: number;
  payid: number;
  payidlinked: number;
  paynetallocation: string;
  paynetamount: number;
  paynetstatus: string;
  paynettype: string;
  siid: number;
  siidcreditnote: number;
  sisid: number;
  cteid:number;
}

export interface tpAddressResponse {
  tpmainadrcity: string;
  tpmainadrcountry: string;
  tpmainadrregion: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
  tpsecadrcity: string;
  tpsecadrcountry: string;
  tpsecadrregion: string;
  tpsecadrstreet1: string;
  tpsecadrstreet2: string;
  tpsecadrzipcode: string;
}

export interface tpContactResponse {
  tpcontactname1: string;
  tpcontactname2: string;
  tpcontactposition1: string;
  tpcontactposition2: string;
  tpemail1: string;
  tpemail2: string;
  tptel1: string;
  tptel2: string;
  tptelmobile1: string;
  tptelmobile2: string;
}

export interface tpGeneralDataResponse {
  countcode: string;
  lancode: string;
  mgid: number;
  tpactivity: string;
  tpbirthcity: string;
  tpbirthcountry: string;
  tpbirthdate: string;
  tpbranchid: number;
  tpcompanycreationdate: string;
  tpfiscalcity: string;
  tpfiscalid: string;
  tpgender: string;
  tpid: number;
  tpidentitycardid: string;
  tpidentitycardtype: string;
  tplegalform: string;
  tpmaidenname: string;
  tpmanagername: string;
  tpmanagerposition: string;
  tpmaritalstatus: string;
  tpmarketingname: string;
  tpmiddlename: string;
  tpname: string;
  tpnbofchildren: number;
  tpprofession: string;
  tpreference: string;
  tpsalutationcode: string;
  tpstatus: string;
  tpstatusdate: string;
  tpsurname: string;
  tptaxid: string;
  tptype: string;
}

export interface FindPaymentByAnyRefOrStatusOrDateParams {
  cireference: string;
  ctreference: string;
  datemax: string;
  datemin: string;
  payallstat: string;
  paydocreference: string;
  paymode: string;
  paydirection: string;
  payreference: string;
  paystatus: string;
  sireference: string;
  tpname: string;
  tpreference: string;
  currcode: string;
  paytype: string;
  flagFilters?: boolean;
}

/**
 * @tags Payment Controller
 * @summary findPaymentByAnyRefOrStatusOrDate
 */
export function findPaymentByAnyRefOrStatusOrDate(
  params: FindPaymentByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, PAYListResponse>>(
    `${URL}/api/payment` +
      prepareQueryParams({
        cireference: params.cireference,
        ctreference: params.ctreference,
        datemax: params.datemax,
        datemin: params.datemin,
        payallstat: params.payallstat,
        paydocreference: params.paydocreference,
        paymode: params.paymode,
        payreference: params.payreference,
        paystatus: params.paystatus,
        sireference: params.sireference,
        tpname: params.tpname,
        tpreference: params.tpreference,
        paydirection: params.paydirection,
        currcode: params.currcode,
        paytype: params.paytype,
      } as any)
  );
}

export interface CreatePaymentParams {
  jobid?: number;
  paymentRequest: PaymentRequest;
}

/**
 * @tags Payment Controller
 * @summary createPayment
 */
export function createPayment(params: CreatePaymentParams) {
  return request.post<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment` + prepareQueryParams({ jobid: params.jobid } as any),
    params.paymentRequest
  );
}

export interface GetClientFlowsByCriteriaParams {
  docdate: string;
  flagCN: boolean;
  flagInvoice: boolean;
  flagPayment: boolean;
  flagReject: boolean;
  paystatus: string;
  tpid: number;
  currcode: string;
}

/**
 * @tags Payment Controller
 * @summary getClientFlowsByCriteria
 */
export function getClientFlowsByCriteria(
  params: GetClientFlowsByCriteriaParams
) {
  return request.get<AbstractResponse<object, clientFlowResponse>>(
    `${URL}/api/payment/clientFlow` +
      prepareQueryParams({
        docdate: params.docdate,
        flagCN: params.flagCN,
        flagInvoice: params.flagInvoice,
        flagPayment: params.flagPayment,
        flagReject: params.flagReject,
        paystatus: params.paystatus,
        tpid: params.tpid,
        currcode: params.currcode,
      } as any)
  );
}

export interface CreateClientInvoicePaymentParams {
  ciid: number;
  jobid?: number;
  paydocreference: string;
}

/**
 * @tags Payment Controller
 * @summary createClientInvoicePayment
 */
export function createClientInvoicePayment(
  params: CreateClientInvoicePaymentParams
) {
  return request.post<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment/clientInvoice` +
      prepareQueryParams({
        ciid: params.ciid,
        jobid: params.jobid,
        paydocreference: params.paydocreference,
      } as any)
  );
}

export interface GetSupplierFlowsByCriteriaParams {
  docdate: string;
  flagCN: boolean;
  flagInvoice: boolean;
  flagPayment: boolean;
  flagReject: boolean;
  paystatus: string;
  tpid: number;
  currcode: string;
}

/**
 * @tags Payment Controller
 * @summary getSupplierFlowsByCriteria
 */
export function getSupplierFlowsByCriteria(
  params: GetSupplierFlowsByCriteriaParams
) {
  return request.get<AbstractResponse<object, SupplierFlowResponse>>(
    `${URL}/api/payment/supplierFlows` +
      prepareQueryParams({
        docdate: params.docdate,
        flagCN: params.flagCN,
        flagInvoice: params.flagInvoice,
        flagPayment: params.flagPayment,
        flagReject: params.flagReject,
        paystatus: params.paystatus,
        tpid: params.tpid,
        currcode: params.currcode,
      } as any)
  );
}

export function getThirdPartyFlowsByCriteria(
  params: GetSupplierFlowsByCriteriaParams
) {
  return request.get<AbstractResponse<object, SupplierFlowResponse>>(
    `${URL}/api/payment/thirdPartyFlows` +
      prepareQueryParams({
        docdate: params.docdate,
        flagCN: params.flagCN,
        flagInvoice: params.flagInvoice,
        flagPayment: params.flagPayment,
        flagReject: params.flagReject,
        paystatus: params.paystatus,
        tpid: params.tpid,
        currcode: params.currcode,
      } as any)
  );
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface GenPaymentParams {
  mgid: number;
  tpidend: number;
  tpidstart: number;
  duedate: string;
  currcode: string;
  targetPayStatus: string;
  autoNetting?: boolean;
}

export interface createPaymentFileParams {
  mgid: number;
  tpidend: number;
  tpidstart: number;
  duedate: string;
  currcode: string;
  targetPayStatus: string;
  mgbkid: number;
  flagforcingbkid: boolean;
  flaggrouping: boolean;
  flagextraction: boolean;
  jobid: number;
}

export function createPaymentFileIN(params: createPaymentFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/createPaymentFileIN` +
      prepareQueryParams({
        mgid: params.mgid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
        duedate: params.duedate,
        currcode: params.currcode,
        targetPayStatus: params.targetPayStatus,
        mgbkid: params.mgbkid,
        flagforcingbkid: params.flagforcingbkid,
        flaggrouping: params.flaggrouping,
        flagextraction: params.flagextraction,
        jobid: params.jobid,
      } as any)
  );
}

export function createPaymentFileOUT(params: createPaymentFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/createPaymentFileOUT` +
      prepareQueryParams({
        mgid: params.mgid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
        duedate: params.duedate,
        currcode: params.currcode,
        targetPayStatus: params.targetPayStatus,
        mgbkid: params.mgbkid,
        flagforcingbkid: params.flagforcingbkid,
        flaggrouping: params.flaggrouping,
        flagextraction: params.flagextraction,
        jobid: params.jobid,
      } as any)
  );
}

export function genClientInvoiceSchedulePayment(params: GenPaymentParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/genPaymentIN` +
      prepareQueryParams({
        mgid: params.mgid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
        duedate: params.duedate,
        currcode: params.currcode,
        targetPayStatus: params.targetPayStatus,
      } as any)
  );
}

export function genSupplierInvoiceSchedulePayment(params: GenPaymentParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/genPaymentOUT` +
      prepareQueryParams({
        mgid: params.mgid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
        duedate: params.duedate,
        currcode: params.currcode,
        targetPayStatus: params.targetPayStatus,
      } as any)
  );
}

export interface CreateSupplierInvoicePaymentParams {
  jobid?: number;
  paydocreference: string;
  siid: number;
}

/**
 * @tags Payment Controller
 * @summary createSupplierInvoicePayment
 */
export function createSupplierInvoicePayment(
  params: CreateSupplierInvoicePaymentParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/payment/supplierInvoice` +
      prepareQueryParams({
        jobid: params.jobid,
        paydocreference: params.paydocreference,
        siid: params.siid,
      } as any)
  );
}

export interface GetPaymentByIdParams {
  payid: number;
}

/**
 * @tags Payment Controller
 * @summary getPaymentById
 */
export function getPaymentById(params: GetPaymentByIdParams) {
  return request.get<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment/${params.payid}`
  );
}

export interface UpdatePaymentParams {
  payid: number;
  paymentRequest: PaymentRequest;
}

/**
 * @tags Payment Controller
 * @summary updatePayment
 */
export function updatePayment(params: UpdatePaymentParams) {
  return request.put<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment/${params.payid}`,
    params.paymentRequest
  );
}

export interface RejectPaymentParams {
  jobid?: number;
  payid: number;
  rejectdate: string;
  rejectreason: string;
}

/**
 * @tags Payment Controller
 * @summary rejectPayment
 */
export function rejectPayment(params: RejectPaymentParams) {
  return request.put<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment/${params.payid}/reject` +
      prepareQueryParams({
        jobid: params.jobid,
        rejectdate: params.rejectdate,
        rejectreason: params.rejectreason,
      } as any)
  );
}

export interface UpdatePayStatusParams {
  jobid?: number;
  payid: number;
  status: string;
}

/**
 * @tags Payment Controller
 * @summary updatePayStatus
 */
export function updatePayStatus(params: UpdatePayStatusParams) {
  return request.put<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/payment/${params.payid}/updateStatus/${params.status}` +
      prepareQueryParams({ jobid: params.jobid } as any)
  );
}

export interface CreateODParams {
  odRequest: PayNetODRequest;
}

/**
 * @tags Payment Controller
 * @summary createOD
 */
export function createOD(params: CreateODParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/paynetting`,
    params.odRequest
  );
}

export interface GetCIPayNettingViewParams {
  ciid: number;
}

/**
 * @tags Payment Controller
 * @summary getCIPayNettingView
 */
export function getCIPayNettingView(params: GetCIPayNettingViewParams) {
  return request.get<AbstractResponse<object, PayNettingViewResponse>>(
    `${URL}/api/paynetting/clientInvoice` +
      prepareQueryParams({ ciid: params.ciid } as any)
  );
}

export interface GetSIPayNettingViewParams {
  siid: number;
}

/**
 * @tags Payment Controller
 * @summary getSIPayNettingView
 */

export function getSIPayNettingView(params: GetSIPayNettingViewParams) {
  return request.get<AbstractResponse<object, PayNettingViewResponse>>(
    `${URL}/api/paynetting/supplierInvoice` +
      prepareQueryParams({ siid: params.siid } as any)
  );
}

export interface GetPAYPayNettingViewParams {
  payid: number;
}
export function getPAYPayNettingView(params: GetPAYPayNettingViewParams) {
  return request.get<AbstractResponse<object, PayNettingViewResponse>>(
    `${URL}/api/paynetting/payment` +
      prepareQueryParams({ payid: params.payid } as any)
  );
}

export interface GetWACCPayNettingViewParams {
  tpid: number;
  currcode: string;
}

/**
 * @tags Payment Controller
 * @summary getWACCPayNettingView
 */
export function getWACCPayNettingView(params: GetWACCPayNettingViewParams) {
  return request.get<AbstractResponse<object, PayNettingViewResponse>>(
    `${URL}/api/paynetting/waitingAccount` +
      prepareQueryParams({
        tpid: params.tpid,
        currcode: params.currcode,
      } as any)
  );
}

export interface GetRefPayNettingViewParams {
  paynetref: string;
}

/**
 * @tags Payment Controller
 * @summary getRefPayNettingView
 */
export function getRefPayNettingView(params: GetRefPayNettingViewParams) {
  return request.get<AbstractResponse<object, PayNettingViewResponse>>(
    `${URL}/api/paynetting/${params.paynetref}`
  );
}

export interface Payfile {
  creationdate: string;
  currcode: string;
  duedate: string;
  filemodel: string;
  flagforcingmgbkid: boolean;
  groupingmode: string;
  jobid: number;
  jobidextraction: number;
  mgbkid: number;
  mgid: number;
  paydirection: string;
  payfiletype: string;
  paymode: string;
  pffolder: string;
  pfid: number;
  pflogfolder: string;
  pfname: string;
  pfstatus: string;
  pftotalamount: number;
  pftotallines: number;
  servicename: string;
  useridcreation: number;
  bankname?: string;
}
export interface GetPayFileByCriteriaParams {
  createdate: string;
  currcode: string;
  mgbkid: number;
  mgid: number;
  paydirection: string;
  paymode: string;
  pfid: number;
  pfstatus: string;
}

/**
 * @tags Payment Controller
 * @summary getPayFileByCriteria
 */
export function getPayFileByCriteria(params: GetPayFileByCriteriaParams) {
  return request.get<AbstractResponse<object, Payfile>>(
    `${URL}/api/payment/paylistfile` +
      prepareQueryParams({
        createdate: params.createdate,
        currcode: params.currcode,
        mgbkid: params.mgbkid,
        mgid: params.mgid,
        paydirection: params.paydirection,
        paymode: params.paymode,
        pfid: params.pfid,
        pfstatus: params.pfstatus,
      } as any)
  );
}

export interface Payfiledetail {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode: string;
  ciduedate: string;
  ctreference: string;
  payamount: number;
  paydirection: string;
  paydocdate: string;
  payduedate: string;
  paylabel: string;
  paynettingdate: string;
  payreference: string;
  payrejectreason: string;
  paystatus: string;
  paytype: string;
  pfdid: number;
  pfid: number;
  sidocdate: string;
  sidocreference: string;
  tpbankname: string;
  tpbkid: number;
  tpiban: string;
  tpname: string;
  tpreference: string;
}

export interface GetPayFileDetailByPfidParams {
  paydocdate: string;
  payduedate: string;
  paystatus: string;
  pfdid: number;
  pfid: number;
  tpname: string;
}

/**
 * @tags Payment Controller
 * @summary getPayFileDetailByPfid
 */
export function getPayFileDetailByPfid(params: GetPayFileDetailByPfidParams) {
  return request.get<AbstractResponse<object, Payfiledetail>>(
    `${URL}/api/payment/paylistfiledetail/${params.pfid}` +
      prepareQueryParams({
        paydocdate: params.paydocdate,
        payduedate: params.payduedate,
        paystatus: params.paystatus,
        pfdid: params.pfdid,
        tpname: params.tpname,
      } as any)
  );
}

export interface ExtractPaymentFileParams {
  extractionModel: string;
  pfid: number;
}

/**
 * @tags Payment Controller
 * @summary extractPaymentFile
 */
export function extractPaymentFileIN(params: ExtractPaymentFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/extractPaymentFileIN` +
      prepareQueryParams({
        pfid: params.pfid,
        extractionModel: params.extractionModel,
      } as any)
  );
}

/**
 * @tags Payment Controller
 * @summary extractPaymentFile
 */
export function extractPaymentFileOUT(params: ExtractPaymentFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/extractPaymentFileOUT` +
      prepareQueryParams({
        pfid: params.pfid,
        extractionModel: params.extractionModel,
      } as any)
  );
}

export interface FileList {
  date: string;
  filename: string;
}

/**
 * @tags Payment Controller
 * @summary getListpayFile
 */
export function getListpayFile() {
  return request.get<AbstractResponse<object, FileList>>(
    `${URL}/api/payment/payfile`
  );
}

export interface BatchJobExecution {
  create_time: string;
  end_time: string;
  errorfile: string;
  exit_code: string;
  exit_message: string;
  job_configuration_location: string;
  job_execution_id: number;
  job_instance_id: number;
  last_updated: string;
  logfile: string;
  logfolder: string;
  module: string;
  outputfile: string;
  outputfolder: string;
  serviceexecparam: string;
  servicename: string;
  start_time: string;
  status: string;
  userid: number;
  version: number;
}

export interface GetJobListByCriteriaParams {
  servicename: string;
  startdate: string;
  status: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getJobListByCriteria
 */
export function getJobListByCriteriaPayement(
  params: GetJobListByCriteriaParams
) {
  return request.get<AbstractResponse<object, BatchJobExecution>>(
    `${URL}/api/job` +
      prepareQueryParams({
        servicename: params.servicename,
        startdate: params.startdate,
        status: params.status,
      } as any)
  );
}

export interface CreateAutoPayNettingByTpidParams {
  currcode: string;
  duedate: string;
  flagForceNetAllocation: boolean;
  flagUseCtrid: boolean;
  mgid: number;
  tpid: number;
}

/**
 * @tags Payment Controller
 * @summary createAutoPayNettingByTpid
 */
export function createAutoPayNettingByTpid(
  params: CreateAutoPayNettingByTpidParams
) {
  return request.get<any>(
    `${URL}/api/payment/createAutoPayNettingByTpid` +
      prepareQueryParams({
        currcode: params.currcode,
        duedate: params.duedate,
        flagForceNetAllocation: params.flagForceNetAllocation,
        flagUseCtrid: params.flagUseCtrid,
        mgid: params.mgid,
        tpid: params.tpid,
      } as any)
  );
}

export interface CreateAutoPayNettingParams {
  currcode: string;
  duedate: string;
  flagForceNetAllocation?: boolean;
  flagUseCtrid?: boolean;
  tpidend: number;
  tpidstart: number;
}

/**
 * @tags Payment Controller
 * @summary createAutoPayNetting
 */
export function createAutoPayNetting(params: CreateAutoPayNettingParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/payment/createAutoPayNetting` +
      prepareQueryParams({
        currcode: params.currcode,
        duedate: params.duedate,
        flagForceNetAllocation: params.flagForceNetAllocation,
        flagUseCtrid: params.flagUseCtrid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
      } as any)
  );
}

export interface RepresentPaymentsParams {
  currcode: string;
  duedate: string;
  flagFilters: boolean;
  mgid: number;
  payidList: Array<number>;
  tpbankaccount: string;
  tpidend: number;
  tpidstart: number;
}

/**
 * @tags Payment Controller
 * @summary representPayments
 */
export function representPayments(params: RepresentPaymentsParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/payment/run/representPayments` +
      prepareQueryParams({
        currcode: params.currcode,
        duedate: params.duedate,
        flagFilters: params.flagFilters,
        mgid: params.mgid,
        tpbankaccount: params.tpbankaccount,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
      } as any),
    params.payidList
  );
}


export interface ImportpaymentfileParams {
  extractionMode?: string;
filename: string;
flagCreatePaymentIfNotExist?: boolean;
payfileorigin?: string;
};


/**
 * @tags Payment Controller
 * @summary importpaymentfile
 */
export function importpaymentfile (params: ImportpaymentfileParams) {
  return request.get<JobExecutionResponse>(`${URL}/api/payment/run/importpaymentfile` + prepareQueryParams({extractionMode: params.extractionMode, filename: params.filename, flagCreatePaymentIfNotExist: params.flagCreatePaymentIfNotExist, payfileorigin: params.payfileorigin} as any))
};
